import request from "@/utils/request.js";

/*查询俱乐部=======================================================================================*/
// 查询俱乐部列表
export const listClub = (pageData, formData) => {
  return request.get(`/club/${pageData.page}/${pageData.pageSize}`, {
    params: formData,
  });
};

// 新增俱乐部
export const addClub = (updateData) => {
  return request.post(`/club`, updateData);
};

// 查询俱乐部详情
export const getClub = (id) => {
  return request.get(`/club/${id}`);
};

// 修改俱乐部信息
export const editClub = (id, updateData) => {
  return request.put(`/club/${id}`, updateData);
};

// 单俱乐部信息--修改
export const editClubInfo = (id, updateData) => {
  return request.put(`/club/clubInfo/${id}`, updateData);
};

// 单俱乐部主理人--修改
export const editPersonInfo = (id, updateData) => {
  return request.put(`/club/personnelInfo/${id}`, updateData);
};

// 删除俱乐部详情
export const deleteClub = (id) => {
  return request.delete(`/club/${id}`);
};

/*俱乐部分类=======================================================================================*/
// 新增俱乐部分类
export const addClubCategory = (updateData) => {
  return request.post(`/club/storeGroup`, updateData);
};

// 查询俱乐部分组列表
export const listClubCategory = (pageData, formData) => {
  return request.get(`/club/storeGroup/${pageData.page}/${pageData.pageSize}`, {
    params: formData,
  });
};

// 删除俱乐部分类
export const deleteClubCategory = (id) => {
  return request.delete(`/club/storeGroup/${id}`);
};

/*俱乐部活动=======================================================================================*/
// 查询俱乐部活动
export const listClubActivity = (pageData, formData) => {
  return request.post(
    `/clubActivity/${pageData.page}/${pageData.pageSize}`,
    formData
  );
};
// 活动列表（运营平台使用）
export const listActivityAdmin = (pageData, formData) => {
  return request.post(
      `/activity/management/${pageData.page}/${pageData.pageSize}`,
      formData
  );
};
// 编辑俱乐部活动-分组关系
export const editClubActivityGroup = (updateData) => {
  return request.put(`/goodsStoreGroup/clubActivity`, updateData);
};
// 俱乐部活动-撤销|发布
export const changeClubActivityState = (updateData) => {
  return request.put(`/clubActivity/storeGoodsState`, updateData);
};
// 活动-撤销|发布|强制下架
export const changeActivityStateAdmin = (updateData) => {
  return request.put(`/activity/management/state`, updateData);
};
// 编辑俱乐部活动-标签关系
export const editClubActivityTags = (updateData) => {
  return request.put(`/goodsTag/clubActivity`, updateData);
};
// 俱乐部活动详情
export const detailClubActivity = (id) => {
  return request.get(`/clubActivity/${id}`);
};
// 活动-详情
export const detailActivityAdmin = (id) => {
  return request.get(`/activity/management/${id}`);
};
// 俱乐部活动-报名者下载(下载的是CSV文件需要自行编写axios请求获取二进制信息)
export const downloadParticipant = (activityId) => {
  return request.post(
    `/clubActivity/download/participant?activityId=${activityId}`,
    {},
    { responseType: "blob" }
  );
};
// 俱乐部活动详情-报名人员列表
export const listClubActivityParticipant = (pageData, activityId) => {
  return request.get(
    `/clubActivity/participant/${pageData.page}/${pageData.pageSize}/${activityId}`
  );
};
// 活动详情-报名人员列表
export const listActivityParticipantAdmin = (pageData, formData) => {
  return request.post(
      `/activity/management/participant/${pageData.page}/${pageData.pageSize}`,
      formData
  );
};
// 俱乐部活动详情-报名人员列表新
export const listClubActivityParticipantNew = (pageData, formData) => {
  return request.post(
    `/clubActivity/participant/${pageData.page}/${pageData.pageSize}`,
    formData
  );
};
// 俱乐部活动-统计
export const getActivityStatistics = () => {
  return request.get(`/clubActivity/statistics`);
};
// 俱乐部活动-编辑-详情
export const detailClubActivityNew = (id) => {
  return request.get(`/clubActivity/clubActivity/${id}`);
};
// 俱乐部活动-添加|修改
export const editClubActivity = (formData) => {
  return request.post(`/clubActivity`, formData);
};
// 活动-添加|修改
export const editActivityAdmin = (formData) => {
  return request.post(`/activity/management`, formData);
};
// 俱乐部活动相册保存
export const activity_album_save = (body_params) => {
  return request.post(`/clubActivity/saveAlbumImage`, body_params);
};
// 活动相册-保存活动图片
export const activity_album_saveAdmin = (body_params) => {
  return request.post(`/activity/management/album/saveAlbumImage`, body_params);
};
// 活动-置顶
export const setActivityTop = (goodsId, updateData) => {
  return request.put(`/activity/management/setTop/${goodsId}?isTop=${updateData.isTop}`);
};

/*俱乐部课程=======================================================================================*/
// 俱乐部课程列表
export const listClubCourse = (pageData, formData) => {
  return request.get(`/clubCourse/${pageData.page}/${pageData.pageSize}`, {
    params: formData,
  });
};
// 编辑俱乐部课程-分组关系
export const editClubCourseGroup = (updateData) => {
  return request.put(`/goodsStoreGroup/clubCourse`, updateData);
};
// 俱乐部课程-上架|下架
export const changeClubCourseState = (updateData) => {
  return request.put(`/clubCourse/storeGoodsState`, updateData);
};

/*俱乐部管理活动报名（订单）=======================================================================================*/
// 活动订单列表
export const listClubSignOrder = (pageData, formData) => {
  return request.post(
    `/activity/order/admin/${pageData.page}/${pageData.pageSize}`,
    formData
  );
};
// 活动订单详情
export const detailClubSignOrder = (id) => {
  return request.get(`/activity/order/admin/${id}`);
};
// 更新活动订单状态
export const updateClubSignOrder = (orderId, updateData) => {
  return request.put(
    `/activity/order/admin/state/${orderId}?state=${updateData.state}`
  );
};
// 活动周边订单列表
export const listClubMerchandiseOrder = (pageData, activityId, formData) => {
  return request.get(
    `/activity/order/admin/merchandise/${pageData.page}/${pageData.pageSize}/${activityId}`,
    { params: formData }
  );
};
// 周边订单信息下载
export const downloadMerchandiseOrder = (activityId, formData) => {
  return request.post(
    `/activity/order/admin/downloadMerchandiseOrder/${activityId}`,
    { params: formData }
  );
};
// 更新订单状态
export const updateMerchandiseOrder = (orderId, formData) => {
  return request.put(`/activity/order/admin/merchandise/state/${orderId}?state=${formData.state}`);
};

/*俱乐部管理课程订单=======================================================================================*/
// 课程订单列表
export const listClubCourseOrder = (pageData, formData) => {
  return request.post(
    `/course/order/admin/${pageData.page}/${pageData.pageSize}`,
    formData
  );
};
// 课程订单详情
export const detailClubCourseOrder = (id) => {
  return request.get(`/course/order/admin/${id}`);
};
// 更新课程订单状态
export const updateClubCourseOrder = (orderId, updateData) => {
  return request.put(
    `/course/order/admin/state/${orderId}?state=${updateData.state}`
  );
};

/*俱乐部赛事=======================================================================================*/
// 俱乐部赛事列表
export const listClubCompetition = (pageData, formData) => {
  return request.post(
    `/competition/${pageData.page}/${pageData.pageSize}`,
    formData
  );
};
// 俱乐部赛事-撤销|发布
export const updateClubCompetition = (updateData) => {
  return request.put(`/competition/storeGoodsState`, updateData);
};

/*俱乐部会员=======================================================================================*/
// 俱乐部会员-列表
export const listClubUser = (pageData, formData) => {
  return request.get(
    `/storeMember/club/${pageData.page}/${pageData.pageSize}`,
    { params: formData }
  );
};
// 俱乐部会员-删除
export const deleteClubUser = (id) => {
  return request.delete(`/storeMember/club/${id}`);
};
// 俱乐部会员-新增
export const addClubUser = (formData) => {
  return request.post(`/storeMember/club`, formData);
};
// 俱乐部会员-统计数据
export const getClubStatistics = () => {
  return request.get(`/storeMember/statistics`);
};
// 俱乐部会员-修改
export const updateClubUser = (updateData) => {
  return request.put(`/storeMember/club`, updateData);
};

/*俱乐部赛事订单=======================================================================================*/
// 赛事订单列表
export const listClubCompetitionOrder = (pageData, formData) => {
  return request.post(
    `/competition/order/admin/${pageData.page}/${pageData.pageSize}`,
    formData
  );
};
// 赛事订单详情
export const detailClubCompetitionOrder = (id) => {
  return request.get(`/competition/order/admin/${id}`);
};
// 赛事更新订单状态
export const updateClubCompetitionOrder = (orderId, updateData) => {
  return request.put(
    `/competition/order/admin/state/${orderId}?state=${updateData.state}`
  );
};

/*俱乐部加入二维码=======================================================================================*/
// 俱乐部会员邀请码
export const createClubQrCode = () => {
  return request.put(`/club/createQrCode`);
};

/*俱乐部活动相册收藏=======================================================================================*/
// 俱乐部收藏照片
export const api_collectActivityPhoto = (body_params) => {
  return request.post(`/albumCollection/club/add`, body_params);
};
// 活动相册-添加收藏
//
export const api_collectActivityPhotoAdmin = (body_params) => {
  return request.post(`/activity/management/album/add`, body_params);
};
// 俱乐部取消收藏照片
export const api_cancelCollectActivityPhoto = (query_params) => {
  return request.delete(
    `/albumCollection/club/remove?albumImageId=${query_params.albumImageId}&storeId=${query_params.storeId}`
  );
};
// 活动相册-取消收藏
export const api_cancelCollectActivityPhotoAdmin = (query_params) => {
  return request.delete(
      `/activity/management/album/remove?albumImageId=${query_params.albumImageId}&storeId=${query_params.storeId}`
  );
};

// 分页查询俱乐部收藏列表
export const api_albumCollectList = (path_params, id) => {
  return request.get(
    `/albumCollection/club/page/${path_params.pageNum}/${path_params.pageSize}?storeId=${id}`
  );
};

// 获取俱乐部主页展示列表
export const api_albumShowList = (query_params) => {
  return request.get(
    `/albumCollection/club/homepage/list?storeId=${query_params.storeId}`
  );
};

// 设置为俱乐部主页展示
export const api_setAlbumShow = (body_params) => {
  return request.post(`/albumCollection/club/homepage/set`, body_params);
};

// 取消主页展示设置
export const api_cancelAlbumShow = (query_params) => {
  return request.delete(
    `/albumCollection/club/homepage/remove?albumImageId=${query_params.albumImageId}&storeId=${query_params.storeId}`
  );
};

// 俱乐部主页展示图片上传
export const api_uploadAlbumShow = (body_params) => {
  return request.post(`/albumCollection/club/homepage/save`, body_params);
};

// 分页获取活动相册
export const api_getAlbum = (page_params, query_params) => {
  return request.get(
    `/clubActivity/album/${page_params.pageNum}/${page_params.pageSize}?goodsId=${query_params.goodsId}&storeId=${query_params.storeId}`
  );
};
// 活动相册
export const api_getAlbumAdmin = (page_params, query_params) => {
  return request.get(
      `/activity/management/album/${page_params.pageNum}/${page_params.pageSize}?goodsId=${query_params.goodsId}&storeId=${query_params.storeId}`
  );
};
